// @generated by tools/codegen from packages/core/config/navigation.json — do not edit by hand.
import type { PhoneArea } from "@bundle/contracts";

/** The app's navigation defaults (core logic/navigation). */
export const NAVIGATION: { readonly phone: { readonly maxTabs: number; readonly areas: readonly PhoneArea[] } } = {
  phone: { maxTabs: 5, areas: ["mail", "calendar", "huddles", "docs", "contacts", "files"] },
};
